import { SweetAlertCustomClass } from 'sweetalert2';

export const SwalLargeFont: SweetAlertCustomClass = {
  popup: 'swal-large-font'
}